import React from 'react'
import { Login as LoginComponent } from '../components'

function Login() {
  return (
    <div>
        <LoginComponent/>
    </div>
  )
}

export default Login
